import React from "react";
import { STATUS_META } from "@/lib/format";

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span data-testid="status-badge" className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${m.cls}`}>
      {m.label}
    </span>
  );
}
